import { format } from 'date-fns'
import { MsgLiquidStakeSDKType } from 'stridejs/dist/types/codegen/stride/stakeibc/tx'
import { isSelectedCoinMinimalDenom, LiquidStakeMetaData } from '@/wallet-utils'
import { MetaDataFactoryParameters } from './types'
import { CHAIN_INFO_LIST } from '@/config'
import { assert } from '@/utils'

const createLiquidStakeMetaData = ({ response, message, denom }: MetaDataFactoryParameters<MsgLiquidStakeSDKType>) => {
  const minimalDenom = CHAIN_INFO_LIST[denom].stakeCurrency.coinMinimalDenom

  assert(isSelectedCoinMinimalDenom(minimalDenom), `Invalid minimal denom ${minimalDenom} for denom ${denom}`)

  const meta: LiquidStakeMetaData = {
    type: 'stake',
    values: {
      hash: response.txhash,
      // Let's add a new property called stakedAmount so we're much more accurate
      // instead of trying to calculate it using the current redemption rate which
      // may be different than when the actual stake occurred.
      amount: message.amount,
      // We are hard-coding this so we don't have to write type-guards.
      // @TODO In the future, maybe on v2, let's remove this as we don't seem to need this to be strictly typed.
      // This assumes that all of the transactions are from Stride
      denom: denom,
      // We are hard-coding this so we don't have to write type-guards.
      // @TODO In the future, maybe on v2, let's remove this as we don't seem to need this to be strictly typed.
      // This assumes that all of the transactions are from Stride
      minimalDenom,
      status: 'complete'
    },
    // @TODO: Refactor this to be unformatted and let StakeTransactionList do its job
    startedAt: format(new Date(response.timestamp), 'MMMM d, yyyy h:mm O'),
    completedAt: null
  }

  return meta
}

export { createLiquidStakeMetaData }
